import * as yup from 'yup';
import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';

const config =  {
    name: 'shortUrl',
    actions: [
        { type: 'request', name: 'getAll' },
        { type: 'request', name: 'getOne' },
        { type: 'request', name: 'create' },
        { type: 'request', name: 'edit' },
        { type: 'request', name: 'delete' }
    ],
    endpoints: {
        shortUrls: '/short-urls',
        shortUrl: '/short-urls/[id]'
    },
    defaults: {
        createShortUrl: {
            originalUrl: '',
            shortCode: '',
        }
    },
    validations: {
        originalUrl: yup.string().url('Invalid URL format').required('Original URL is required'),
        shortCode: yup.string().required('Short code is required'),
    }
}

const Config = {
    Actions: ModuleBootstrapper.getActions(config.name, config.actions),
    Endpoints: config.endpoints,
    Defaults: config.defaults,
    Validations: config.validations,
    ...ModuleBootstrapper.getUtils(),
}

export default Config;
